import { useNavigate } from "react-router-dom";
import {handleLogout} from './../../../../../Redux/action/interactions'
import { useDispatch } from "react-redux";
import toast from 'react-hot-toast';

export const useOptions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const options = [
    {
      id: 1,
      moduleName:"ATTENDANCE",
      optionName: "e-Visiting Card",
      icon: "account_circle",
      func: () => {
        navigate("/dashboard/profile");
      },
    },
    {
      id: 2,
      moduleName:"ATTENDANCE",
      optionName: "Change Profile Photo",
      icon: "confirmation_number",
      func: () => {
        navigate("/dashboard/changeface");
      },
    },
    {
      id: 3,
      optionName: "Change Password",
      icon: "lock",
      func: () => {
        navigate("/dashboard/changepass");
      },
    },
    // {
    //   id: 4,
    //   optionName: "View Ticket",
    //   icon: "confirmation_number",
    //   func: () => {
    //     console.log("Hello");
    //   },
    // },
    {
      id: 4,
      moduleName:"ATTENDANCE",
      optionName: "How To Mark Attendance",
      icon: "how_to_reg",
      func: () => {
        navigate("/onboarding/1");
      },
    },
    {
      id: 5,
      optionName: "Update App",
      icon: "system_update",
      func: () => {
        toast.success('App has been updated succesfully',{
          duration:4500
        })
        caches.keys().then((names) => {
            names.forEach((name) => {
                caches.delete(name);
            });
        });
        localStorage.clear();
        navigate("/");
      },
    },
    {
      id: 6,
      optionName: "Sign Out",
      icon: "exit_to_app",
      func: () => {
        localStorage.removeItem('data');
        localStorage.removeItem('userID');
        localStorage.removeItem('modules');
        localStorage.removeItem('location');
        localStorage.removeItem('fetchedLoc');
        navigate("/");
        dispatch(handleLogout());
        toast.success("You've been successfully Logged Out ");
      },
    },

    // {
    //   id: 7,
    //   moduleName:"ATTENDANCE",
    //   optionName: "Privacy policy",
    //   icon: "tips_and_updates",
    //   func: () => {
    //     navigate("/onboarding/8");
    //   },
    // },

  ];

  return options;
};
